import {FC, useEffect} from 'react'
import {Routes, Route, BrowserRouter} from 'react-router-dom';
import {PrivateRoutes} from "./PrivateRoutes";
import {initTracking} from "../../tracking/trackingService";
import {useAction} from "../../store/hooks/useAction";
import {useTypedSelector} from "../../store/hooks/useTypedSelector";

const AppRoutes: FC = () => {
    const {initOperator} = useAction();
    const {operatorData} = useTypedSelector((state) => state.operatorReducer);
    console.log(operatorData, 'lobbi');
    useEffect(() => {
        initOperator();
    }, []);
    useEffect(() => {
        if (Object.keys(operatorData).length > 0) {
            initTracking(operatorData.operator);
        }
    }, [operatorData]);
    return (
        <BrowserRouter basename={'/'}>
            <Routes>
                <Route path='/*' element={<PrivateRoutes />} />
            </Routes>
        </BrowserRouter>
    )
}

export {AppRoutes}
